module.exports = __webpack_public_path__ + "img/location_a02.528293bf.svg";